
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.674.617A2.037 2.037 0 004.65 2.64v1.157a.867.867 0 00.036.248l-1.413-.002C1.553 3.953.154 5.329.005 6.97L0 7.013l.038 4.659.005-.088c-.106 1.143.376 2.328 1.4 2.99l.07.045.077.03c.865.346 1.449.436 1.904.451v.26c0 1.106.917 2.024 2.023 2.024h6.938a2.039 2.039 0 002.024-2.024v-.296c.583.007 1.21-.074 1.818-.409.663-.317 1.106-.878 1.344-1.445.24-.574.316-1.163.332-1.69v-.004c.038-1.596.014-3.176.027-4.736v-.115l-.027-.11c-.358-1.382-1.578-2.264-2.866-2.476l-.07-.011h-.07l-1.687-.005a.867.867 0 00.002-.002.867.867 0 00.04-.264V2.64A2.037 2.037 0 0011.3.617zm0 1.734h4.625c.17 0 .29.12.29.29v1.156a.867.867 0 00.042.264L6.346 4.05a.867.867 0 00.039-.253V2.64c0-.17.119-.289.289-.289zM3.182 5.775l.023.002h.022l11.611.025c.65.115 1.262.612 1.425 1.166-.01 1.518.01 3.022-.025 4.505-.012.385-.078.779-.198 1.066-.121.289-.26.453-.49.56l-.034.016-.034.02c-.27.155-.617.19-1.003.183v-1.427a2.039 2.039 0 00-2.024-2.024H5.517a2.039 2.039 0 00-2.023 2.024v1.475c-.259-.016-.555-.085-1.134-.307-.385-.28-.637-.8-.59-1.315l.005-.043-.038-4.582c.07-.702.771-1.38 1.445-1.344zm2.335 5.827h6.938c.176 0 .29.114.29.29v3.468c0 .175-.114.29-.29.29H5.517c-.175 0-.289-.115-.289-.29v-3.469c0-.175.114-.289.29-.289z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    